import { render, staticRenderFns } from "./SoftnetDocumentsChips.vue?vue&type=template&id=102bc6a4&"
import script from "./SoftnetDocumentsChips.vue?vue&type=script&lang=js&"
export * from "./SoftnetDocumentsChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports